// routes/luxotticaAuthRoutes.js
//
// Logto hosts the actual sign-in / registration / password-reset UI at
// auth.parallelia.com, so these routes are just entry points that redirect
// there, plus the callback Logto returns to.

import AuthRedirect from '@/pages/auth-redirect';
import AuthCallback from '@/pages/auth-callback';
import LuxotticaUnauthorizedPage from '@/pages/luxottica-unathorized';

const luxotticaAuthRoutes = [
  {
    path: '/login',
    element: <AuthRedirect />
  },
  {
    path: '/register',
    element: <AuthRedirect firstScreen="register" />
  },
  {
    // Logto's own sign-in page links to password reset; landing here just sends
    // the user there rather than 404ing an old bookmark.
    path: '/forgot-password',
    element: <AuthRedirect firstScreen="resetPassword" />
  },
  {
    path: '/callback',
    element: <AuthCallback />
  },
  {
    path: '/unauthorized',
    element: <LuxotticaUnauthorizedPage />
  }
];

export default luxotticaAuthRoutes;
